import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reportMutations } from "../../../../mutations";
import { reportQueries } from "../../../../queries";

interface RestartReportStepParams {
  reportId: string;
  stepId: string;
}

export function useRestartReportStep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ reportId, stepId }: RestartReportStepParams) => {
      const response = await reportMutations.analysisStep.restartStep(
        reportId,
        stepId,
      );
      if (response.error) throw response.error;
      return { reportId, stepId };
    },
    onSuccess: (_data, { reportId }) => {
      void queryClient.invalidateQueries(reportQueries.steps(reportId));
      void queryClient.invalidateQueries(reportQueries.detail(reportId));
    },
  });
}
